// src/api/index.js
import axios from "axios";
import CryptoJS from "crypto-js";
import qs from 'qs';
const api = axios.create({
	baseURL: process.env.REACT_APP_API_URL,
	withCredentials: true, // 쿠키 허용
});
function restoreTypes(obj) {
	const restored = {};

	for (const [key, value] of Object.entries(obj)) {
		// 이미 올바른 타입이면 그대로
		if (typeof value !== 'string') {
			restored[key] = value;
			continue;
		}

		// boolean 복원
		if (value === "true") {
			restored[key] = true;
		}
		else if (value === "false") {
			restored[key] = false;
		}
		// null 복원
		else if (value === "null") {
			restored[key] = null;
		}
		// undefined 복원
		else if (value === "undefined") {
			restored[key] = undefined;
		}
		// 빈 문자열은 그대로
		else if (value === "") {
			restored[key] = value;
		}
		// 숫자 복원 (정수/실수 구분)
		else if (!isNaN(value) && !isNaN(parseFloat(value))) {
			const num = parseFloat(value);
			// 정수인지 실수인지 판단
			if (Number.isInteger(num) && value.indexOf('.') === -1) {
				restored[key] = parseInt(value, 10); // 정수로 복원
			} else {
				restored[key] = num; // 실수로 복원
			}
		}
		// 나머지는 문자열로 유지
		else {
			restored[key] = value;
		}
	}

	return restored;
}

const SECRET_KEY = process.env.REACT_APP_SECRET_KEY
function encryptAES(obj) {

	const key = CryptoJS.SHA256(SECRET_KEY);
	const iv = CryptoJS.lib.WordArray.random(16);

	const encrypted = CryptoJS.AES.encrypt(JSON.stringify(obj), key, {
		iv: iv,
		mode: CryptoJS.mode.CBC,
		padding: CryptoJS.pad.Pkcs7,
	});

	const payload = CryptoJS.enc.Base64.stringify(iv.concat(encrypted.ciphertext));

	return payload;
}

api.interceptors.request.use((config) => {
	if (config.headers["Content-Type"] === "multipart/form-data" && config.data instanceof FormData) {

		if (config.url.includes("/auth") || config.url.includes("/admin") || config.url.includes("/file/data") || config.url.includes("/payments")) {
			const obj = {};
			config.data.forEach((value, key) => {
				obj[key] = value;
			});

			// JSON 직렬화 + AES 암호화
			//const encrypted = CryptoJS.AES.encrypt(JSON.stringify(obj), SECRET_KEY).toString();
			const restored = restoreTypes(obj);
			const payload = encryptAES(restored);

			// 새 FormData에 payload만 담음
			const encryptedFormData = new FormData();
			encryptedFormData.append("payload", payload);

			config.data = encryptedFormData;

		}
		else {

			// const encryptedFormData = new FormData();

			// config.data.forEach((value, key) => {
			// 	if (value instanceof File) {
			// 		// 파일은 그대로 추가
			// 		encryptedFormData.append(key, value);
			// 	} else {
			// 		// 문자열만 암호화 처리
			// 		const encrypted = CryptoJS.AES.encrypt(value, SECRET_KEY).toString();
			// 		encryptedFormData.append(key, encrypted);
			// 	}
			// });

			// config.data = encryptedFormData;
		}

	}
	return config;
});
let interceptorsSet = false;
// Axios 인터셉터
export const setupInterceptors = (navigate) => {
	if (interceptorsSet) return;
	api.interceptors.response.use(
		response => {
			// const path = window.location.pathname;

			// if (path.startsWith("/login") ) 
			// 	navigate("/main"); // 👈 여기만 추가하면 끝

			// if (window.location.pathname === "/" ) 
			// {

			// }
			return response;
		},
		error => {
			// 401 Unauthorized 발생 시 로그인으로 이동
			const path = window.location.pathname;

			// 1) 약관 페이지는 인증 체크 제외
			if (path.startsWith("/terms") || path.startsWith("/privacy") || path.startsWith("/marketing") || path.startsWith("/login")) return; // 👈 여기만 추가하면 끝

			if (error.response?.status === 401) {
				navigate("/"); // 로그인 페이지
			}
			return Promise.reject(error);
		}
	);

	interceptorsSet = true;
};


export const serverCheck = () => api.get(`/server/check`);
// export const getLinks = () => api.get(`/auth/links`);
// export const getLinks = (link_type) => 
//     api.get('/auth/links', {
//         params: { link_type }  // { link_type: value } 형태로 보내면 ?link_type=value 로 전송
//     });
export const getLinks = (types) => {
	const typeArray = Array.isArray(types) ? types : types ? [types] : [];

	return api.get('/auth/links', {
		params: { link_type: typeArray },
		paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
		// link_type=guide&link_type=news 형식
	});
};
export const updateMarketing = (data) => api.post(`/auth/marketing-term/update`, data, {
	headers: { "Content-Type": "multipart/form-data" }
});
// 예시 API
export const getAuth = () => api.get(`/auth/user`);
export const userLogin = (data) => api.post(`/auth/login`, data, {
	headers: { "Content-Type": "multipart/form-data" }
});
export const adminLogin = (data) => api.post(`/admin/login`, data, {
	headers: { "Content-Type": "multipart/form-data" }
});
export const getAdminUsers = (page, limit, excludeCompany = false) => api.get(`/admin/users`, {
	params: { page, limit, exclude_company: excludeCompany }
});
export const getUserHistory = (userId, excludeCompany = false) => api.get(`/admin/users/${userId}/history`, {
	params: { exclude_company: excludeCompany }
});
export const getUserPayments = (userId) => api.get(`/admin/users/${userId}/payments`);
export const getFeedbacks = (excludeCompany = false) => api.get(`/admin/feedbacks`, {
	params: { exclude_company: excludeCompany }
});
export const getFeedbackDetails = (optimizeId) => api.get(`/admin/feedbacks/${optimizeId}`);
export const getAdminStats = (excludeCompany = false) => api.get(`/admin/stats`, {
	params: { exclude_company: excludeCompany }
});
export const getChartData = (metric, granularity, excludeCompany = false) => api.get(`/admin/chart-data`, {
	params: { metric, granularity, exclude_company: excludeCompany }
});

// Notice Management
export const getAdminNotices = () => api.get(`/admin/notices`);
export const addAdminNotice = (data) => api.post(`/admin/notices`, data, {
	headers: { "Content-Type": "multipart/form-data" }
});
export const updateAdminNotice = (id, data) => api.put(`/admin/notices/${id}`, data, {
	headers: { "Content-Type": "multipart/form-data" }
});
export const deleteAdminNotice = (id) => api.delete(`/admin/notices/${id}`);

// Notification Management
export const getAdminNotifications = () => api.get(`/admin/notifications`);
export const addAdminNotification = (data) => api.post(`/admin/notifications`, data, {
	headers: { "Content-Type": "multipart/form-data" }
});
export const updateAdminNotification = (id, data) => api.put(`/admin/notifications/${id}`, data, {
	headers: { "Content-Type": "multipart/form-data" }
});
export const deleteAdminNotification = (id) => api.delete(`/admin/notifications/${id}`);

// Public Notice
export const fetchPublicNotice = (lang) => api.get(`/notice/`, {
	params: { lang }
});
export const tempLogin = () => api.post(`/auth/login/temp`, null, {
	headers: { "Content-Type": "multipart/form-data" }
});
export const userPasswordCheck = (data) => api.post(`/auth/password/check`, data, {
	headers: { "Content-Type": "multipart/form-data" }
});
export const userPasswordChange = (data) => api.post(`/auth/password/change`, data, {
	headers: { "Content-Type": "multipart/form-data" }
});


export const userDataChange = (data) => api.post(`/auth/user-data/update`, data, {
	headers: { "Content-Type": "multipart/form-data" }
});


export const userLogout = () => api.post(`/auth/logout`);
export const userDeleteAccount = (data) => api.post(`/auth/delete/account`, data, {
	headers: { "Content-Type": "multipart/form-data" }
});
export const userSignup = (data) => api.post(`/auth/signup`, data, {
	headers: { "Content-Type": "multipart/form-data" }
});
export const userResetPassword = (data) => api.post(`/auth/password/reset`, data, {
	headers: { "Content-Type": "multipart/form-data" }
});

export const sendVerityCode = (data) => api.post(`/auth/email-verify`, data, {
	headers: { "Content-Type": "multipart/form-data" }
});
export const VerityCode = (data) => api.post(`/auth/email-verify/check`, data, {
	headers: { "Content-Type": "multipart/form-data" }
});


export const getUserData = () => api.get(`/user/data`);
export const getOptimizeHistoryData = () => api.get(`/user/history`);


export const getInputExtension = () => api.get(`/user/extension/input`);
export const getOutputExtension = () => api.get(`/user/extension/output`);

export const getAnalyzeModel = (data, header = {}) => api.post(`/analyze/upload`, data, {
	headers: {
		"Content-Type": "multipart/form-data",
		...header,
	}
});
export const getAnalyzeResult = (data, header = {}) => api.post(`/analyze/result`, data, {
	headers: {
		"Content-Type": "multipart/form-data",
		...header,
	}
});
export const getAnalyzeSTPModel = (data, header = {}) => api.post(`/analyze/upload/stp`, data, {
	headers: {
		"Content-Type": "multipart/form-data",
		...header,
	}
});

export const getPreviewModel = (data, header = {}) => api.post(`/preview/upload`, data, {
	headers: {
		"Content-Type": "multipart/form-data",
		...header,
	}
});
export const getPreviewResult = (data, header = {}) => api.post(`/preview/result`, data, {
	headers: {
		"Content-Type": "multipart/form-data",
		...header,
	}
});
export const optimizeModel = (data, header = {}) => api.post(`/optimize/upload`, data, {
	headers: {
		"Content-Type": "multipart/form-data",
		...header,
	}
});
export const optimizeResultStatus = (data, header = {}) => api.post(`/optimize/result`, data, {
	headers: {
		"Content-Type": "multipart/form-data",
		...header,
	}
});
export const optimizeResult = (data) => api.post(`/user/optimize-result`, data, {
	headers: {
		"Content-Type": "multipart/form-data",
	}
});
export const sendFeedback = (data) => api.post(`/user/feedback`, data, {
	headers: {
		"Content-Type": "multipart/form-data",
	}
});
export const getFeedback = (data) => api.get(`/user/feedback`);

export const sendSpecialSurvey = (data) => api.post(`/user/feedback/special`, data, {
	headers: {
		"Content-Type": "multipart/form-data",
	}
});
export const getSpecialSurvey = (data) => api.get(`/user/feedback/special`);



export const sendAddCountFeedback = (data) => api.post(`/user/feedback/add-count`, data, {
	headers: {
		"Content-Type": "multipart/form-data",
	}
});


export const planDescription = (params) => api.get(`/user/plan/description`, { params });

export const getPlanAddCount = () => api.get(`/user/plan/addition-count`);

export const checkUsage = (data) => api.post(`/user/usage/check`, data, {
	headers: {
		"Content-Type": "multipart/form-data",
	}
});


export const getDeleteReason = () => api.get(`/auth/delete/reason`);

export const uploadMtlFile = (data) => api.post(`/analyze/upload/mtl`, data, {
	headers: {
		"Content-Type": "multipart/form-data",
	}
});
export const checkFirstLogin = () => api.get(`/user/check-first`);

export const googleAuth = (data) => api.post(`/auth/google/auth`, data, {
	headers: { "Content-Type": "multipart/form-data" }
});


export const getOptimizeFileData = (data) => api.post(`/file/data`, data, {
	headers: {
		"Content-Type": "multipart/form-data",
	}
});


export const getPlanList = (data) => api.post(`/payments/plan/list`, data, {
	headers: {
		"Content-Type": "multipart/form-data",
	}
});
export const PaymentSubscribe = (data) => api.post(`/payments/subscribe`, data, {
	headers: {
		"Content-Type": "multipart/form-data",
	}
});
export const PaymentChangeBillingKey = (data) => api.post(`/payments/billing-key`, data, {
	headers: {
		"Content-Type": "multipart/form-data",
	}
});
export const getPaymentHistory = (page = 1, limit = 10) => api.get(`/payments/history`, {
	params: { page, limit }
});
export const getCreditsHistory = (page = 1, limit = 10) => api.get(`/payments/credits/history`, {
	params: { page, limit }
});
export const getPaymentMethod = () => api.get(`/payments/method`);
export const getPaymentDetail = (id) => api.get(`/payments/history/detail`, {
	params: { id }
});
export const getCurrentPlan = (lang) => {
	const formData = new FormData();
	formData.append("lang", lang);
	return api.post(`/payments/plan/current`, formData, {
		headers: {
			"Content-Type": "multipart/form-data",
		}
	});
};
export const getCurrentDetailPlan = (lang) => {
	const formData = new FormData();
	formData.append("lang", lang);
	return api.post(`/payments/plan/current/detail`, formData, {
		headers: {
			"Content-Type": "multipart/form-data",
		}
	});
};

export const getCancelReason = (lang) => {
	const formData = new FormData();
	formData.append("lang", lang);
	return api.post(`/payments/subscribe/cancellation/reasons`, formData, {
		headers: {
			"Content-Type": "multipart/form-data",
		}
	});
};

export const userCancelSubscribe = (data) => api.post(`/payments/subscribe/cancellation`, data, {
	headers: { "Content-Type": "multipart/form-data" }
});

export const userResumeSubscribe = (data) => api.post(`/payments/subscribe/resume`, data, {
	headers: { "Content-Type": "multipart/form-data" }
});



export const getAddonPrices = (data) => api.post(`/payments/addon/prices`, data, {
	headers: { "Content-Type": "multipart/form-data" }
});

export const PaymentCreditPurchase = (data) => api.post(`/payments/addon/credit/complete`, data, {
	headers: {
		"Content-Type": "multipart/form-data",
	}
});

export const getPaymentId = (data) => api.post(`/payments/payment-id/${data}`);
export const getBillingkeyIssueId = () => api.post(`/payments/billing-key/issue-id`);
export const getPaymentStatus = (paymentId) => api.get(`/payments/status/${paymentId}`);

export const PaymentStoragePurchase = (data) => api.post(`/payments/addon/storage/complete`, data, {
	headers: {
		"Content-Type": "multipart/form-data",
	}
});

export const getCurrentStorageAddon = () => api.get(`/payments/addon/storage/current`);

export const reduceStorageAddon = (data) => api.post(`/payments/addon/storage/reduce`, data, {
	headers: { "Content-Type": "multipart/form-data" }
});
